import { render, staticRenderFns } from "./customerSendMessage.vue?vue&type=template&id=116debc4"
import script from "./customerSendMessage.vue?vue&type=script&lang=js"
export * from "./customerSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports